'use strict';

window.TIPOS_OCORRENCIA = [
  { id: 'doenca', descricao: 'Doença' },
  { id: 'inimigo_natural', descricao: 'Inimigo Natural' },
  { id: 'inseto', descricao: 'Inseto' },
  { id: 'invasora', descricao: 'Invasora' },
  { id: 'nematoide', descricao: 'Nematóide' }
];

window.CLASSIFICACOES_INVASORA = [
  { id: null, descricao: 'Outra' },
  { id: 'atipica', descricao: 'Atípica' },
  { id: 'outra_especie', descricao: 'Outra espécie cultivada' },
  { id: 'nociva_tolerada', descricao: 'Nociva Tolerada' },
  { id: 'nociva_proibida', descricao: 'Nociva Proibida' }
];

// eslint-disable-next-line max-lines-per-function,max-params,max-len,complexity
angular.module('webAgro1App').factory('TiposOcorrenciasService', function($http, $q, RestService, TipoOcorrenciaObjectService) {
  // eslint-disable-next-line complexity
  const getFilters = function(filters) {
    return !filters ? {} : {
      descricao: filters.descricao || null,
      tipo: (filters.tipo || {}).id || null,
      exibir: filters.exibir || null,
      page: filters.page || null,
      no_paginate: filters.noPaginate || null
    };
  };

  const urlTiposOcorrencias = function() {
    return `${SERVER + API_VERSION }/ocorrencias`;
  };

  return {
    list: function(filters) {
      const params = getFilters(filters);
      return RestService.getFromUrl(`${urlTiposOcorrencias() }/tipos`, params);
    },

    listWithInfestation: function() {
      return $http.get(`${urlTiposOcorrencias()}/mapa_infestacao/subtipos`);
    },

    listTipoOcorrencia: function(id) {
      return $http.get(`${urlTiposOcorrencias() }/tipos/${ id}`);
    },

    save: function(tipoOcorrencia) {
      const result = TipoOcorrenciaObjectService.convertToSend(tipoOcorrencia);
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${urlTiposOcorrencias() }/tipos`,
        data: { tipo_ocorrencia: result }
      });
    },

    update: function(tipoOcorrencia) {
      const result = TipoOcorrenciaObjectService.convertToSend(tipoOcorrencia);
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${urlTiposOcorrencias() }/tipos/${ result.id}`,
        data: { tipo_ocorrencia: result }
      });
    },

    getTipoOcorrencia: function(id) {
      const deferred = $q.defer();

      this.listTipoOcorrencia(id).then(function(data) {
        const tipoOcorrencia = TipoOcorrenciaObjectService.convertToObject(data.data);
        deferred.resolve(tipoOcorrencia);
      }, deferred.reject);

      return deferred.promise;
    },

    deleteTipo(tipo) {
      return $http.delete(`${urlTiposOcorrencias()}/tipos/${tipo.id}`);
    },

    restoreTipo(tipo) {
      return $http.patch(`${urlTiposOcorrencias()}/tipos/${tipo.id}`, {
        tipo_ocorrencia: { ativo: 'S' }
      });
    }
  };
});
